// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Стили для компонента аналитики */

/* Основные стили карточек */
.stat-card {
  transition: all 0.3s ease;
  margin-bottom: 16px !important;
  border-radius: 8px !important;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}

.stat-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-3px);
}

.stat-card .ant-card-head {
  padding: 12px 16px !important;
  background-color: #fafafa;
  border-bottom: 1px solid #f0f0f0 !important;
}

.stat-card .ant-card-head-title {
  font-size: 16px !important;
  font-weight: 600 !important;
}

.stat-card .ant-card-body {
  padding: 16px !important;
}

/* Стили для внутренних карточек */
.stat-card .ant-card-small {
  box-shadow: none !important;
  border: 1px solid #f0f0f0 !important;
}

.stat-card .ant-card-small .ant-card-head {
  min-height: auto !important;
  padding: 8px 12px !important;
  background-color: #fafafa;
}

.stat-card .ant-card-small .ant-card-head-title {
  font-size: 14px !important;
  padding: 0 !important;
}

.stat-card .ant-card-small .ant-card-body {
  padding: 12px !important;
}

/* Стили для статистики */
.ant-statistic-title {
  font-size: 13px !important;
  margin-bottom: 4px !important;
  color: #666 !important;
}

.ant-statistic-content {
  font-size: 18px !important;
}

/* Стили для тегов */
.ant-tag {
  margin-right: 0 !important;
  font-weight: 500 !important;
  border-radius: 12px !important;
  padding: 0 8px !important;
  line-height: 20px !important;
  height: 22px !important;
}

/* Стили для панели поиска и фильтров */
.search-filter-panel {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.ant-select-selection-placeholder {
  color: #bbb !important;
}

.ant-select-selection-item {
  font-weight: 500 !important;
}

/* Стили для пагинации */
.ant-pagination {
  margin-top: 24px !important;
  text-align: center !important;
}

.ant-pagination-item-active {
  font-weight: 600 !important;
}

/* Стили для загрузчика */
.loading-container {
  text-align: center;
  padding: 40px 0;
}

.loading-text {
  margin-top: 16px;
  color: #666;
}

/* Стили для пустого состояния */
.ant-empty {
  padding: 40px 0 !important;
}

.ant-empty-description {
  color: #666 !important;
}

/* Стили для текста */
.ant-typography {
  margin-bottom: 0 !important;
}

.ant-typography strong {
  font-weight: 600 !important;
}

/* Стили для адаптивности */
@media (max-width: 768px) {
  .ant-card-head-title {
    font-size: 15px !important;
  }
  
  .ant-statistic-content {
    font-size: 16px !important;
  }
  
  .ant-tag {
    font-size: 10px !important;
    padding: 0 6px !important;
    line-height: 18px !important;
    height: 20px !important;
  }
  
  .ant-card-small .ant-card-head-title {
    font-size: 13px !important;
  }
}

/* Стили для улучшения отображения текста шаблона */
.template-content {
  max-height: 120px;
  overflow-y: auto;
  padding-right: 8px;
}

.template-content::-webkit-scrollbar {
  width: 4px;
}

.template-content::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 4px;
}

.template-title {
  font-weight: 600 !important;
  margin-bottom: 6px !important;
}

.template-text {
  margin-bottom: 0 !important;
  white-space: pre-line !important;
}

/* Стили для улучшения отображения меток статистики */
.stat-label {
  display: block;
  font-size: 12px;
  color: #888;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

/* Стили для заголовка страницы */
.page-title {
  display: flex;
  align-items: center;
  margin-bottom: 24px !important;
}

.page-title-icon {
  font-size: 24px;
  margin-right: 12px;
  color: #1abc9c;
}

.page-title-text {
  font-size: 24px !important;
  font-weight: 600 !important;
  margin: 0 !important;
  color: #333 !important;
}

/* Дополнительные стили для исправления проблем с отображением */

/* Исправление ширины селектора условий */
.ant-select {
  width: 100% !important;
}

/* Ограничение ширины и центрирование содержимого */
.ant-card-wider {
  max-width: 1200px !important;
  margin: 0 auto !important;
}

/* Исправление для стилей статистики и процентов */
.stat-card .ant-statistic {
  display: flex;
  margin-bottom: 0 !important;
  flex-direction: column;
  align-items: center;
}

.percentage-tag-container {
  margin-top: 4px !important;
  display: block !important;
}

/* Выравнивание кнопки экспорта */
.export-button {
  margin-left: 12px !important;
  flex-shrink: 0 !important;
}

/* Исправление для выпадающего меню селектора */
.ant-select-dropdown {
  min-width: 200px !important;
}

/* Исправление лейаута поисковой панели */
.search-filter-row {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 12px !important;
  margin-bottom: 16px !important;
}

.search-filter-col {
  flex: 1 1 !important;
  min-width: 200px !important;
}

.button-col {
  flex-shrink: 0 !important;
  display: flex !important;
  align-items: flex-start !important;
}

/* Улучшение стилей для процентных тегов */
.percentage-tag {
  display: flex !important;
  padding: 2px 8px !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  line-height: 1.5 !important;
  margin-top: 4px !important;
  align-items: center;
    justify-content: center;
}

/* Исправление для мобильной версии */
@media (max-width: 576px) {
  .search-filter-row {
    flex-direction: column !important;
    gap: 8px !important;
  }
  
  .button-col {
    margin-top: 8px !important;
    align-self: flex-end !important;
  }
  
  .stat-value-container {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
  }
  
  .percentage-tag {
    margin-left: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/analytic-styles.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,kCAAkC;AAClC;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,4BAA4B;IAC5B,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,mDAAmD;AACnD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA,qDAAqD;AACrD;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,gEAAgE;;AAEhE,yCAAyC;AACzC;EACE,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,oBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;IACjB,uBAAuB;AAC3B;;AAEA,qCAAqC;AACrC;EACE;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;EAC3C;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/* Стили для компонента аналитики */\r\n\r\n/* Основные стили карточек */\r\n.stat-card {\r\n  transition: all 0.3s ease;\r\n  margin-bottom: 16px !important;\r\n  border-radius: 8px !important;\r\n  overflow: hidden;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\r\n}\r\n\r\n.stat-card:hover {\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\r\n  transform: translateY(-3px);\r\n}\r\n\r\n.stat-card .ant-card-head {\r\n  padding: 12px 16px !important;\r\n  background-color: #fafafa;\r\n  border-bottom: 1px solid #f0f0f0 !important;\r\n}\r\n\r\n.stat-card .ant-card-head-title {\r\n  font-size: 16px !important;\r\n  font-weight: 600 !important;\r\n}\r\n\r\n.stat-card .ant-card-body {\r\n  padding: 16px !important;\r\n}\r\n\r\n/* Стили для внутренних карточек */\r\n.stat-card .ant-card-small {\r\n  box-shadow: none !important;\r\n  border: 1px solid #f0f0f0 !important;\r\n}\r\n\r\n.stat-card .ant-card-small .ant-card-head {\r\n  min-height: auto !important;\r\n  padding: 8px 12px !important;\r\n  background-color: #fafafa;\r\n}\r\n\r\n.stat-card .ant-card-small .ant-card-head-title {\r\n  font-size: 14px !important;\r\n  padding: 0 !important;\r\n}\r\n\r\n.stat-card .ant-card-small .ant-card-body {\r\n  padding: 12px !important;\r\n}\r\n\r\n/* Стили для статистики */\r\n.ant-statistic-title {\r\n  font-size: 13px !important;\r\n  margin-bottom: 4px !important;\r\n  color: #666 !important;\r\n}\r\n\r\n.ant-statistic-content {\r\n  font-size: 18px !important;\r\n}\r\n\r\n/* Стили для тегов */\r\n.ant-tag {\r\n  margin-right: 0 !important;\r\n  font-weight: 500 !important;\r\n  border-radius: 12px !important;\r\n  padding: 0 8px !important;\r\n  line-height: 20px !important;\r\n  height: 22px !important;\r\n}\r\n\r\n/* Стили для панели поиска и фильтров */\r\n.search-filter-panel {\r\n  margin-bottom: 16px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.ant-select-selection-placeholder {\r\n  color: #bbb !important;\r\n}\r\n\r\n.ant-select-selection-item {\r\n  font-weight: 500 !important;\r\n}\r\n\r\n/* Стили для пагинации */\r\n.ant-pagination {\r\n  margin-top: 24px !important;\r\n  text-align: center !important;\r\n}\r\n\r\n.ant-pagination-item-active {\r\n  font-weight: 600 !important;\r\n}\r\n\r\n/* Стили для загрузчика */\r\n.loading-container {\r\n  text-align: center;\r\n  padding: 40px 0;\r\n}\r\n\r\n.loading-text {\r\n  margin-top: 16px;\r\n  color: #666;\r\n}\r\n\r\n/* Стили для пустого состояния */\r\n.ant-empty {\r\n  padding: 40px 0 !important;\r\n}\r\n\r\n.ant-empty-description {\r\n  color: #666 !important;\r\n}\r\n\r\n/* Стили для текста */\r\n.ant-typography {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.ant-typography strong {\r\n  font-weight: 600 !important;\r\n}\r\n\r\n/* Стили для адаптивности */\r\n@media (max-width: 768px) {\r\n  .ant-card-head-title {\r\n    font-size: 15px !important;\r\n  }\r\n  \r\n  .ant-statistic-content {\r\n    font-size: 16px !important;\r\n  }\r\n  \r\n  .ant-tag {\r\n    font-size: 10px !important;\r\n    padding: 0 6px !important;\r\n    line-height: 18px !important;\r\n    height: 20px !important;\r\n  }\r\n  \r\n  .ant-card-small .ant-card-head-title {\r\n    font-size: 13px !important;\r\n  }\r\n}\r\n\r\n/* Стили для улучшения отображения текста шаблона */\r\n.template-content {\r\n  max-height: 120px;\r\n  overflow-y: auto;\r\n  padding-right: 8px;\r\n}\r\n\r\n.template-content::-webkit-scrollbar {\r\n  width: 4px;\r\n}\r\n\r\n.template-content::-webkit-scrollbar-thumb {\r\n  background-color: #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\n.template-title {\r\n  font-weight: 600 !important;\r\n  margin-bottom: 6px !important;\r\n}\r\n\r\n.template-text {\r\n  margin-bottom: 0 !important;\r\n  white-space: pre-line !important;\r\n}\r\n\r\n/* Стили для улучшения отображения меток статистики */\r\n.stat-label {\r\n  display: block;\r\n  font-size: 12px;\r\n  color: #888;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.stat-value {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n/* Стили для заголовка страницы */\r\n.page-title {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 24px !important;\r\n}\r\n\r\n.page-title-icon {\r\n  font-size: 24px;\r\n  margin-right: 12px;\r\n  color: #1abc9c;\r\n}\r\n\r\n.page-title-text {\r\n  font-size: 24px !important;\r\n  font-weight: 600 !important;\r\n  margin: 0 !important;\r\n  color: #333 !important;\r\n}\r\n\r\n/* Дополнительные стили для исправления проблем с отображением */\r\n\r\n/* Исправление ширины селектора условий */\r\n.ant-select {\r\n  width: 100% !important;\r\n}\r\n\r\n/* Ограничение ширины и центрирование содержимого */\r\n.ant-card-wider {\r\n  max-width: 1200px !important;\r\n  margin: 0 auto !important;\r\n}\r\n\r\n/* Исправление для стилей статистики и процентов */\r\n.stat-card .ant-statistic {\r\n  display: flex;\r\n  margin-bottom: 0 !important;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.percentage-tag-container {\r\n  margin-top: 4px !important;\r\n  display: block !important;\r\n}\r\n\r\n/* Выравнивание кнопки экспорта */\r\n.export-button {\r\n  margin-left: 12px !important;\r\n  flex-shrink: 0 !important;\r\n}\r\n\r\n/* Исправление для выпадающего меню селектора */\r\n.ant-select-dropdown {\r\n  min-width: 200px !important;\r\n}\r\n\r\n/* Исправление лейаута поисковой панели */\r\n.search-filter-row {\r\n  display: flex !important;\r\n  flex-wrap: wrap !important;\r\n  gap: 12px !important;\r\n  margin-bottom: 16px !important;\r\n}\r\n\r\n.search-filter-col {\r\n  flex: 1 !important;\r\n  min-width: 200px !important;\r\n}\r\n\r\n.button-col {\r\n  flex-shrink: 0 !important;\r\n  display: flex !important;\r\n  align-items: flex-start !important;\r\n}\r\n\r\n/* Улучшение стилей для процентных тегов */\r\n.percentage-tag {\r\n  display: flex !important;\r\n  padding: 2px 8px !important;\r\n  border-radius: 10px !important;\r\n  font-weight: 600 !important;\r\n  font-size: 12px !important;\r\n  line-height: 1.5 !important;\r\n  margin-top: 4px !important;\r\n  align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n/* Исправление для мобильной версии */\r\n@media (max-width: 576px) {\r\n  .search-filter-row {\r\n    flex-direction: column !important;\r\n    gap: 8px !important;\r\n  }\r\n  \r\n  .button-col {\r\n    margin-top: 8px !important;\r\n    align-self: flex-end !important;\r\n  }\r\n  \r\n  .stat-value-container {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: space-between !important;\r\n  }\r\n  \r\n  .percentage-tag {\r\n    margin-left: auto !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
